import { HttpMethod } from "../components/Common/useFetch";
import { RequestOptions } from "../components/Common/useRequest";
import useUserRequest from "../components/Common/useUserRequest";
import { useSelectedBusiness } from "../components/UserAccess/useSelectedBusiness";

export interface GenerateDataSharingCodeRequest {
  siteId: string;
}

export interface GenerateDataSharingCodeResponse {
  code: string;
}

const useGenerateDataSharingCode = (options?: RequestOptions<GenerateDataSharingCodeResponse>) => {
  const business = useSelectedBusiness();
  return useUserRequest<GenerateDataSharingCodeRequest, GenerateDataSharingCodeResponse>({
    path: `/api/businesses/${business.id}/dataSharing/generateCode`,
    method: HttpMethod.POST,
  }, options);
}

export default useGenerateDataSharingCode;